export default __webpack_public_path__ + "static/iphone-mockup-9f9617c73359495690c38f6aedbc9ee9.png";